import React, {ReactNode} from 'react';
import clsx from "clsx";
import {Typography} from "@mui/material";

export interface ErrorProps {
  children: ReactNode
}

export const Error = (props: ErrorProps) => {
  return (
    <>
      <Typography variant="body2" component="span" className={clsx('jc-error-message', 'j-error')}>
        {props.children}
      </Typography>
    </>
  );
}

export default Error;
